export enum MileageType {
  None = 'none',
  Mileage = 'mileage',
  MileageSincePurchase = 'mileage_since_purchase'
}
